import { render, staticRenderFns } from "./LocalPiecesList.vue?vue&type=template&id=4c4ce115&scoped=true&"
import script from "./LocalPiecesList.vue?vue&type=script&lang=js&"
export * from "./LocalPiecesList.vue?vue&type=script&lang=js&"
import style0 from "./LocalPiecesList.vue?vue&type=style&index=0&id=4c4ce115&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4ce115",
  null
  
)

export default component.exports